import { render, staticRenderFns } from "./brandTendencyTop.vue?vue&type=template&id=07ceed74&scoped=true&"
import script from "./brandTendencyTop.vue?vue&type=script&lang=js&"
export * from "./brandTendencyTop.vue?vue&type=script&lang=js&"
import style0 from "./brandTendencyTop.vue?vue&type=style&index=0&id=07ceed74&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ceed74",
  null
  
)

export default component.exports